import { Plus } from "lucide-react";
import React from "react";

import { IgButton, IgTooltip } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

interface AddAnotherButtonProps {
  onAddClick: () => void;
  itemLabel: string;
  isDisabled?: boolean;
}

export const AddAnotherButton = ({
  onAddClick,
  itemLabel,
  isDisabled,
}: AddAnotherButtonProps) => {
  return (
    <Grid item width={"fit-content"}>
      <IgTooltip
        title={isDisabled ? "A maximum of 5 URL conditions can be added" : ""}
      >
        <IgButton
          startIcon={<Plus size={16} />}
          variant={"text"}
          sx={{
            width: "100%",
          }}
          onClick={onAddClick}
          disabled={isDisabled}
        >
          {itemLabel}
        </IgButton>
      </IgTooltip>
    </Grid>
  );
};
